(function () {

 

  // ==========================================
  // GALLERY â€” thumbnail + arrow navigation
  // ==========================================
  const mainImage = document.getElementById('mainImage');
  const thumbs = document.querySelectorAll('.thumb');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  const counter = document.getElementById('imageCounter');
  const sources = Array.from(thumbs).map(t => t.dataset.image);
  let currentIndex = 0;
  const total = sources.length;

  function updateGallery(index) {
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;
    currentIndex = index;
    mainImage.style.opacity = '0';
    setTimeout(() => {
      mainImage.src = sources[currentIndex];
      mainImage.style.opacity = '1';
    }, 150);
    thumbs.forEach((t, i) => t.classList.toggle('active', i === currentIndex));
    if (counter) counter.textContent = `${currentIndex + 1} / ${total}`;
  }

  thumbs.forEach((thumb, idx) =>
    thumb.addEventListener('click', () => updateGallery(idx))
  );
  if (prevBtn) prevBtn.addEventListener('click', () => updateGallery(currentIndex - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => updateGallery(currentIndex + 1));

  // ==========================================
  // QUANTITY SELECTORS (HERO & STICKY BOTTOM BAR)
  // ==========================================
  const minus = document.getElementById('minusBtn');
  const plus  = document.getElementById('plusBtn');
  const input = document.getElementById('quantityInput');

  const stickyMinus = document.getElementById('stickyMinusBtn');
  const stickyPlus  = document.getElementById('stickyPlusBtn');
  const stickyInput = document.getElementById('stickyQuantityInput');

  function setQuantity(newVal) {
    let val = Math.max(1, Math.min(10, parseInt(newVal) || 1));
    if (input) input.value = val;
    if (stickyInput) stickyInput.value = val;
  }

  if (minus) minus.addEventListener('click', () => setQuantity((parseInt(input?.value) || 1) - 1));
  if (plus)  plus.addEventListener('click',  () => setQuantity((parseInt(input?.value) || 1) + 1));

  if (stickyMinus) stickyMinus.addEventListener('click', () => setQuantity((parseInt(stickyInput?.value) || 1) - 1));
  if (stickyPlus)  stickyPlus.addEventListener('click',  () => setQuantity((parseInt(stickyInput?.value) || 1) + 1));

  // ==========================================
  // TABS (DESKTOP)
  // ==========================================
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const tabId = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      const target = document.getElementById(tabId);
      if (target) target.classList.add('active');
    });
  });

  // ==========================================
  // MOBILE PRODUCT ACCORDIONS
  // ==========================================
  const accHeaders = document.querySelectorAll('.acc-header');
  accHeaders.forEach(header => {
    header.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const item = header.closest('.acc-item');
      if (!item) return;

      const arrow = header.querySelector('.acc-arrow');
      const isActive = item.classList.contains('active');
      
      // Close all mobile product accordions
      document.querySelectorAll('.acc-item').forEach(i => {
        i.classList.remove('active');
        const a = i.querySelector('.acc-arrow');
        if (a) a.textContent = 'â–¼';
      });

      // Toggle clicked item
      if (!isActive) {
        item.classList.add('active');
        if (arrow) arrow.textContent = 'â–²';
      }
    });
  });

  // ==========================================
  // RITUAL CAROUSEL DOT SYNC (MOBILE)
  // ==========================================
  const ritualCarousel = document.querySelector('.mobile-ritual-carousel');
  const ritualDots = document.querySelectorAll('.ritual-dot');

  if (ritualCarousel && ritualDots.length > 0) {
    ritualCarousel.addEventListener('scroll', () => {
      const scrollPos = ritualCarousel.scrollLeft;
      const cardWidth = 274; // 260px card + 14px gap
      const activeIdx = Math.round(scrollPos / cardWidth);
      ritualDots.forEach((dot, idx) => {
        dot.classList.toggle('active', idx === activeIdx);
      });
    });
  }

  // ==========================================
  // FOOTER ACCORDIONS (MOBILE)
  // ==========================================
  const footerAccHeaders = document.querySelectorAll('.footer-acc-header');
  footerAccHeaders.forEach(header => {
    header.addEventListener('click', (e) => {
      if (window.innerWidth > 768) return;
      e.preventDefault();
      e.stopPropagation();
      const item = header.closest('.footer-acc-item');
      if (!item) return;

      const isActive = item.classList.contains('active');
      document.querySelectorAll('.footer-acc-item').forEach(i => i.classList.remove('active'));

      if (!isActive) {
        item.classList.add('active');
      }
    });
  });

  // ==========================================
  // FAQ ACCORDION
  // ==========================================
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const button = item.querySelector('.faq-question');
    if (button) {
      button.addEventListener('click', () => {
        faqItems.forEach(faq => {
          if (faq !== item) faq.classList.remove('active');
        });
        item.classList.toggle('active');
      });
    }
  });

  // ==========================================
  // DELIVERY CHECKER
  // ==========================================
  const checkBtn = document.querySelector('.check-btn');
  const pincodeInput = document.querySelector('.pincode-input');
  const deliveryResult = document.querySelector('.delivery-result');
  if (checkBtn && pincodeInput && deliveryResult) {
    checkBtn.addEventListener('click', () => {
      const pin = pincodeInput.value.trim();
      if (pin.length === 6 && /^\d+$/.test(pin)) {
        const deliveryDate = new Date();
        deliveryDate.setDate(deliveryDate.getDate() + 4);
        const options = { weekday: 'long', month: 'short', day: 'numeric' };
        const dateStr = deliveryDate.toLocaleDateString('en-IN', options);
        deliveryResult.innerHTML = `âœ… Delivers by <strong>${dateStr}</strong> &nbsp;â€¢&nbsp; Dispatched in 24 hrs &nbsp;â€¢&nbsp; COD Available`;
        deliveryResult.style.color = '#2E7D32';
      } else {
        deliveryResult.textContent = 'âš ï¸ Please enter a valid 6-digit pincode';
        deliveryResult.style.color = '#C62828';
      }
    });
    pincodeInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') checkBtn.click();
    });
  }

  // ==========================================
  // STICKY ATC BAR â€” show after scrolling past buttons
  // ==========================================
  const stickyAtc = document.getElementById('stickyAtc');
  const buyButtons = document.querySelector('.buttons');

  if (stickyAtc && buyButtons) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            stickyAtc.classList.add('visible');
          } else {
            stickyAtc.classList.remove('visible');
          }
        });
      },
      { threshold: 0.5 }
    );
    observer.observe(buyButtons);
  }

  // Sticky ATC button clicks
  const stickyBuy  = document.querySelector('.sticky-buy');
  const stickyCart = document.querySelector('.sticky-cart');
  if (stickyBuy)  stickyBuy.addEventListener('click',  () => { alert('Redirecting to checkoutâ€¦'); });
  if (stickyCart) stickyCart.addEventListener('click', () => {
    const count = document.querySelector('.cart-count');
    if (count) count.textContent = parseInt(count.textContent || '0') + 1;
    stickyCart.textContent = 'Added! âœ“';
    setTimeout(() => { stickyCart.textContent = 'Add to Cart'; }, 1800);
  });

  // ==========================================
  // ADD TO CART â€” main button feedback + cart count
  // ==========================================
  const cartBtn = document.getElementById('addToCartBtn');
  if (cartBtn) {
    cartBtn.addEventListener('click', () => {
      const count = document.querySelector('.cart-count');
      if (count) count.textContent = parseInt(count.textContent || '0') + 1;
      const orig = cartBtn.textContent;
      cartBtn.textContent = 'Added! âœ“';
      cartBtn.style.background = '#2E7D32';
      cartBtn.style.color = 'white';
      cartBtn.style.borderColor = '#2E7D32';
      setTimeout(() => {
        cartBtn.textContent = orig;
        cartBtn.style.background = '';
        cartBtn.style.color = '';
        cartBtn.style.borderColor = '';
      }, 1800);
    });
  }

  // ==========================================
  // SCROLL REVEAL ANIMATIONS
  // ==========================================
  const revealElements = document.querySelectorAll('.reveal');
  if (revealElements.length > 0) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.delay || 0;
            setTimeout(() => {
              entry.target.classList.add('revealed');
            }, delay);
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    revealElements.forEach(el => {
      const parent = el.parentElement;
      if (parent) {
        const siblings = Array.from(parent.querySelectorAll('.reveal'));
        const siblingIndex = siblings.indexOf(el);
        if (siblings.length > 1) {
          el.dataset.delay = siblingIndex * 110;
        }
      }
      revealObserver.observe(el);
    });
  }

  // ==========================================
  // BUTTON PRESS MICRO-FEEDBACK
  // ==========================================
  document.querySelectorAll('.buy, .cart, .feature-btn, .productbtn, .write-review-btn, .check-btn, .sticky-buy, .sticky-cart').forEach(btn => {
    btn.addEventListener('mousedown', () => { btn.style.transform = 'scale(0.97)'; });
    btn.addEventListener('mouseup',   () => { btn.style.transform = ''; });
    btn.addEventListener('mouseleave',() => { btn.style.transform = ''; });
  });

 

  // ==========================================
  // GALLERY TOUCH SWIPE (MOBILE)
  // ==========================================
  const galleryWrapper = document.querySelector('.main-image');
  if (galleryWrapper) {
    let touchStartX = 0;
    let touchEndX = 0;

    galleryWrapper.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    galleryWrapper.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const diff = touchEndX - touchStartX;
      if (Math.abs(diff) > 40) {
        if (diff < 0) {
          updateGallery(currentIndex + 1); // Swipe left -> Next
        } else {
          updateGallery(currentIndex - 1); // Swipe right -> Prev
        }
      }
    }
  }



})();